import { skipToken } from "@reduxjs/toolkit/query";

import { useGetDimensionQuery } from "api/dimensionApi.slice";
import { useSelector } from "common/utilities/react-redux";
import { getNewCustomDimensions } from "domains/createMapDetail/selectors";
import { getDimensionUploadId } from "domains/customKeyIssue/selectors";

export const useUploadDimension = () => {
  const dimensionId = useSelector(getDimensionUploadId);
  const newCustomDimensions = useSelector(getNewCustomDimensions);

  const newDimension = newCustomDimensions.find((dimension) => dimension.id === dimensionId);

  const arg = dimensionId === undefined || newDimension !== undefined ? skipToken : { id: dimensionId };
  const { data, isFetching, isSuccess } = useGetDimensionQuery(arg, { refetchOnMountOrArgChange: true });

  return {
    dimension: newDimension ?? (isSuccess ? { ...data.dimension, topics: data.topics } : undefined),
    isFetching,
  };
};
